module.exports=[
  {
    path:'main.sol',
    content:`
    pragma solidity ^0.8.0;
    contract SampleContract {
      address admin;
      mapping(address => uint256) private _balances; 
         mapping(address => mapping(address => uint256)) private _allowances; 
         uint256 private _totalSupply; 
         string private _name; 
         string private _symbol; 
         event Transfer(address indexed from, address indexed to, uint256 value); 
         event Approval(address indexed owner, address indexed spender, uint256 value); 
      constructor(string memory name_, string memory symbol_) { 
            _name = name_; 
            _symbol = symbol_; 
            admin = msg.sender;
        }
      function name() public view virtual  returns (string memory) { 
            return _name; 
        }
      function symbol() public view virtual  returns (string memory) { 
            return _symbol; 
        }
      function decimals() public view virtual  returns (uint8) { 
            return 18; 
        }
      function totalSupply() public view virtual  returns (uint256) { 
            return _totalSupply; 
        }
      function balanceOf(address account) public view virtual  returns (uint256) { 
            return _balances[account]; 
        }
      function transfer(address to, uint256 amount) public virtual  returns (bool) { 
            address owner = msg.sender; 
            _transfer(owner, to, amount); 
            return true; 
        }
      function allowance(address owner, address spender) public view virtual  returns (uint256) { 
            return _allowances[owner][spender]; 
        }
      function approve(address spender, uint256 amount) public virtual  returns (bool) { 
            address owner = msg.sender; 
            _approve(owner, spender, amount); 
            return true; 
        }
      function transferFrom( 
            address from, 
            address to, 
            uint256 amount 
        ) public virtual  returns (bool) { 
            address spender = msg.sender; 
            _spendAllowance(from, spender, amount); 
            _transfer(from, to, amount); 
            return true; 
        }
      function increaseAllowance(address spender, uint256 addedValue) public virtual returns (bool) { 
            address owner = msg.sender; 
            _approve(owner, spender, allowance(owner, spender) + addedValue); 
            return true; 
        }
      function decreaseAllowance(address spender, uint256 subtractedValue) public virtual returns (bool) { 
            address owner = msg.sender; 
            uint256 currentAllowance = allowance(owner, spender); 
            require(currentAllowance >= subtractedValue, "ERC20: decreased allowance below zero"); 
            unchecked { 
                _approve(owner, spender, currentAllowance - subtractedValue); 
            } 
            return true; 
        }
      function _transfer( 
            address from, 
            address to, 
            uint256 amount 
        ) internal virtual { 
            require(from != address(0), "ERC20: transfer from the zero address"); 
            require(to != address(0), "ERC20: transfer to the zero address"); 
            uint256 fromBalance = _balances[from]; 
            require(fromBalance >= amount, "ERC20: transfer amount exceeds balance"); 
            unchecked { 
                _balances[from] = fromBalance - amount; 
                _balances[to] += amount; 
            } 
            emit Transfer(from, to, amount); 
        }
      function mint(address account, uint256 amount) public { 
            require(account != address(0), "ERC20: mint to the zero address"); 
            require(msg.sender==admin);
            _totalSupply += amount; 
            _balances[account] += amount; 
            emit Transfer(address(0), account, amount); 
        }
      function burn(address account, uint256 amount) public { 
            require(account != address(0), "ERC20: burn from the zero address"); 
            uint256 accountBalance = _balances[account]; 
            require(accountBalance >= amount, "ERC20: burn amount exceeds balance"); 
            unchecked { 
                _balances[account] = accountBalance - amount; 
                _totalSupply -= amount; 
            } 
            emit Transfer(account, address(0), amount); 
        }
      function _approve( 
            address owner, 
            address spender, 
            uint256 amount 
        ) internal virtual { 
            require(owner != address(0), "ERC20: approve from the zero address"); 
            require(spender != address(0), "ERC20: approve to the zero address"); 
            _allowances[owner][spender] = amount; 
            emit Approval(owner, spender, amount); 
        }
      function _spendAllowance( 
            address owner, 
            address spender, 
            uint256 amount 
        ) internal virtual { 
            uint256 currentAllowance = allowance(owner, spender); 
            if (currentAllowance != type(uint256).max) { 
                require(currentAllowance >= amount, "ERC20: insufficient allowance"); 
                unchecked { 
                    _approve(owner, spender, currentAllowance - amount); 
                } 
            } 
        }      
    }
    `}]